/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monthly_Challenge_Description_CollectedInputs */

const en_monthly_challenge_description_collected = /** @type {(inputs: Monthly_Challenge_Description_CollectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've completed this challenge! Great job!`)
};

const ar_monthly_challenge_description_collected = /** @type {(inputs: Monthly_Challenge_Description_CollectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لقد أكملت هذا التحدي! عمل رائع!`)
};

const de_monthly_challenge_description_collected = /** @type {(inputs: Monthly_Challenge_Description_CollectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast diese Herausforderung gemeistert! Tolle Arbeit!`)
};

const es_monthly_challenge_description_collected = /** @type {(inputs: Monthly_Challenge_Description_CollectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Has completado este desafío! ¡Buen trabajo!`)
};

const fr_monthly_challenge_description_collected = /** @type {(inputs: Monthly_Challenge_Description_CollectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez réussi ce défi ! Beau travail !`)
};

const it_monthly_challenge_description_collected = /** @type {(inputs: Monthly_Challenge_Description_CollectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai completato questa sfida! Ottimo lavoro!`)
};

const ja_monthly_challenge_description_collected = /** @type {(inputs: Monthly_Challenge_Description_CollectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チャレンジ達成です！お見事！`)
};

const ko_monthly_challenge_description_collected = /** @type {(inputs: Monthly_Challenge_Description_CollectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`챌린지를 완료하셨습니다! 정말 멋져요!`)
};

const pt_br_monthly_challenge_description_collected = /** @type {(inputs: Monthly_Challenge_Description_CollectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você concluiu este desafio! Bom trabalho!`)
};

const ru_monthly_challenge_description_collected = /** @type {(inputs: Monthly_Challenge_Description_CollectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы справились с этим испытанием! Отличная работа!`)
};

const th_monthly_challenge_description_collected = /** @type {(inputs: Monthly_Challenge_Description_CollectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณทำความท้าทายนี้สำเร็จแล้ว! เยี่ยมมาก!`)
};

const tr_monthly_challenge_description_collected = /** @type {(inputs: Monthly_Challenge_Description_CollectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu mücadeleyi tamamladın! Harika iş!`)
};

const zh_cn_monthly_challenge_description_collected = /** @type {(inputs: Monthly_Challenge_Description_CollectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本月挑战顺利完成啦，给自己来点掌声！`)
};

const zh_tw_monthly_challenge_description_collected = /** @type {(inputs: Monthly_Challenge_Description_CollectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本月挑戰順利完成啦，給自己來點掌聲！`)
};

/**
* | output |
* | --- |
* | "You've completed this challenge! Great job!" |
*
* @param {Monthly_Challenge_Description_CollectedInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const monthly_challenge_description_collected = /** @type {((inputs?: Monthly_Challenge_Description_CollectedInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monthly_Challenge_Description_CollectedInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_monthly_challenge_description_collected(inputs)
	if (locale === "ar") return ar_monthly_challenge_description_collected(inputs)
	if (locale === "de") return de_monthly_challenge_description_collected(inputs)
	if (locale === "es") return es_monthly_challenge_description_collected(inputs)
	if (locale === "fr") return fr_monthly_challenge_description_collected(inputs)
	if (locale === "it") return it_monthly_challenge_description_collected(inputs)
	if (locale === "ja") return ja_monthly_challenge_description_collected(inputs)
	if (locale === "ko") return ko_monthly_challenge_description_collected(inputs)
	if (locale === "pt_br") return pt_br_monthly_challenge_description_collected(inputs)
	if (locale === "ru") return ru_monthly_challenge_description_collected(inputs)
	if (locale === "th") return th_monthly_challenge_description_collected(inputs)
	if (locale === "tr") return tr_monthly_challenge_description_collected(inputs)
	if (locale === "zh_cn") return zh_cn_monthly_challenge_description_collected(inputs)
	return zh_tw_monthly_challenge_description_collected(inputs)
});